(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/form/assets/javascripts/components/inputv2.trinidad.js') >= 0) return;  svs.modules.push('/components/ui/form/assets/javascripts/components/inputv2.trinidad.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
(() => {
  "use strict";

  const __webpack_require__ = {};
  __webpack_require__.n = module => {
const getter = module && module.__esModule ? () => module['default'] : () => module;
    __webpack_require__.d(getter, {
      a: getter
    });
    return getter;
  };
  __webpack_require__.d = (exports, definition) => {
for (var key in definition) {
if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
Object.defineProperty(exports, key, {
          enumerable: true,
          get: definition[key]
        });
      }
    }
  };
  __webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
  let __webpack_exports__ = {};

  __webpack_require__.d(__webpack_exports__, {
    "default": () => (inputv2)
  });
  ; 
  const external_PropTypes_namespaceObject = window["PropTypes"];
  var external_PropTypes_default = __webpack_require__.n(external_PropTypes_namespaceObject);
  ; 
  const external_React_namespaceObject = window["React"];
  ; 
  const external_svs_ui_ReactIcon_namespaceObject = window["svs"]["ui"]["ReactIcon"];
  var external_svs_ui_ReactIcon_default = __webpack_require__.n(external_svs_ui_ReactIcon_namespaceObject);
  ; 
  const _excluded = ["autoCapitalize", "autoComplete", "className", "hasFormData", "id", "inputHelpText", "inverted", "label", "multiline", "selectOnFocus", "onFocus", "prefix", "suffix", "size", "refElem", "isSmall", "showPassword"];
  function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function (n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
      }
      return n;
    }, _extends.apply(null, arguments);
  }
  function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      r && (o = o.filter(function (r) {
        return Object.getOwnPropertyDescriptor(e, r).enumerable;
      })), t.push.apply(t, o);
    }
    return t;
  }
  function _objectSpread(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = null != arguments[r] ? arguments[r] : {};
      r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
        _defineProperty(e, r, t[r]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
      });
    }
    return e;
  }
  function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }
  function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
  }
  function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var i = e.call(t, r || "default");
      if ("object" != typeof i) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
  }
  function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o,
      r,
      i = _objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
  }
  function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
      if (-1 !== e.indexOf(n)) continue;
      t[n] = r[n];
    }
    return t;
  }

  ;

  const Inputv2 = _ref => {
    let autoCapitalize = _ref.autoCapitalize,
      autoComplete = _ref.autoComplete,
      className = _ref.className,
      hasFormData = _ref.hasFormData,
      id = _ref.id,
      inputHelpText = _ref.inputHelpText,
      inverted = _ref.inverted,
      label = _ref.label,
      multiline = _ref.multiline,
      selectOnFocus = _ref.selectOnFocus,
      onFocus = _ref.onFocus,
      prefix = _ref.prefix,
      suffix = _ref.suffix,
      size = _ref.size,
      refElem = _ref.refElem,
      isSmall = _ref.isSmall,
      showPassword = _ref.showPassword,
      props = _objectWithoutProperties(_ref, _excluded);
    const inputWrapper = (0, external_React_namespaceObject.useRef)(null);
    const eyeIcon = (0, external_React_namespaceObject.useRef)(null);
    const _ref2 = (0, external_React_namespaceObject.useState)(showPassword),
      _ref3 = _slicedToArray(_ref2, 2),
      showPwd = _ref3[0],
      setPwdVisibility = _ref3[1];
    const handleToggle = () => {
      if (props.onClick) {
        props.onClick();
      }
      if (props.type === 'password') {
        if (showPwd) {
          inputWrapper.current.querySelector('.js-standard-input').type = 'text';
        } else {
          inputWrapper.current.querySelector('.js-standard-input').type = 'password';
        }
        setPwdVisibility(!showPwd);
      }
    };
    const classes = ['input-control'];
    const inputClasses = ['js-standard-input standard-input'];
    const inputProps = _objectSpread(_objectSpread({}, props), selectOnFocus ? {
      onFocus: event => {
        event.target.select();
        onFocus && onFocus(event);
      }
    } : {
      onFocus: event => {
        onFocus && onFocus(event);
      }
    });
    if (inverted) {
      classes.push('input-control-inverted');
    } else {
      classes.push('input-control-default');
    }
    if (prefix) {
      inputClasses.push('input-has-prefix');
    }
    if (className) {
      inputClasses.push(className);
      classes.push(className);
    }
    if (multiline) {
      classes.push('input-control-textarea');
    }
    if (inputProps.value) {
      inputClasses.push('input-valid');
    }
    let inputField;
    if (multiline) {
      inputField = React.createElement("textarea", _extends({
        "aria-label": "".concat(label).concat(inputHelpText ? ", - ".concat(inputHelpText) : ''),
        autoCapitalize: autoCapitalize,
        autoComplete: autoComplete,
        className: inputClasses.join(' '),
        cols: inputProps.cols ? inputProps.cols : '1',
        id: id,
        ref: refElem,
        rows: inputProps.rows ? inputProps.rows : '1'
      }, inputProps));
    } else {
      inputField = React.createElement("input", _extends({
        "aria-label": "".concat(label).concat(inputHelpText ? ", - ".concat(inputHelpText) : ''),
        autoCapitalize: autoCapitalize,
        autoComplete: autoComplete,
        className: inputClasses.join(' '),
        id: id,
        ref: refElem,
        value: inputProps.value
      }, inputProps));
    }
    const setSuffixWidth = input => {
      input = input.querySelector('.js-standard-input');
      const sufxEl = input.nextElementSibling.querySelector('.input-sufx');
      if (input.style.width.length === 0) {
        input.style.width = input.clientWidth > 0 ? "".concat(input.clientWidth - input.nextElementSibling.querySelector('.input-trailing').clientWidth, "px") : "calc(100% - 40px)";
      }
      if (inputProps.type === 'password') {
        sufxEl.style.cursor = 'pointer';
      }
    };
    const setPrefixWidth = input => {
      input = input.querySelector('.js-standard-input');
      const inputLabel = input.nextElementSibling.querySelector('.original-label');

      if (inputLabel.style.textIndent.length === 0) {
        inputLabel.style.textIndent = "".concat(!input.value.length ? input.nextElementSibling.querySelector('.input-prefx').clientWidth : 0, "px");
      }
      if (input.style.paddingLeft.length === 0) {
        input.style.paddingLeft = "".concat(input.nextElementSibling.querySelector('.input-prefx').clientWidth + 18, "px");
      }
    };
    (0, external_React_namespaceObject.useEffect)(() => {
      if (suffix) {
        setSuffixWidth(inputWrapper.current);
      }
      if (prefix) {
        setPrefixWidth(inputWrapper.current);
      }
    });
    if (inputProps.type === 'password') {
      suffix = React.createElement(external_svs_ui_ReactIcon_default(), {
        color: inverted ? 'fc-white' : 'fc-navy',
        icon: showPwd ? 'eye-closed' : 'eye',
        size: "200"
      });
    }
    return React.createElement("div", {
      className: classes.join(' '),
      ref: inputWrapper
    }, inputField, React.createElement("div", {
      className: "input-look ".concat(inputProps.disabled ? 'input-look-disabled' : '')
    }, React.createElement("div", {
      className: "input-leading ".concat(prefix ? 'input-leading-has-prefix' : '')
    }, React.createElement("div", {
      className: "input-prefx"
    }, prefix)), React.createElement("div", {
      className: "input-notch"
    }, React.createElement("div", {
      className: "input-north-notch"
    }, React.createElement("label", {
      "aria-hidden": "true",
      className: "forms-label js-label-".concat(id, " ").concat(inputProps.value ? 'hide-label' : ''),
      htmlFor: id
    }, React.createElement("span", {
      className: "original-label"
    }, label), React.createElement("span", {
      className: "help-text-label"
    }, inputHelpText ? inputHelpText : label))), React.createElement("div", {
      className: "input-south-notch"
    })), React.createElement("div", {
      className: "standard-input-middle"
    }), React.createElement("div", {
      className: "input-trailing",
      onClick: handleToggle,
      ref: eyeIcon
    }, React.createElement("div", {
      className: "input-sufx"
    }, suffix))));
  };
  Inputv2.defaultProps = {
    autoCapitalize: 'off',
    autoComplete: 'on',
    className: '',
    hasFormData: false,
    isSmall: false,
    prefix: null,
    refElem: null,
    selectOnFocus: true,
    showPassword: true,
    suffix: null
  };
  Inputv2.__docgenInfo = {
    "description": "Text input allows the user to freely input text. If appropriate allowed input can be restricted to for example only numerical characters or a limited number of characters. If the input required is limited to discrete smaller amount of options, a dropdown (components select & dropdown) can be considered a better option.\n\n## Label\nBefore interaction the input-field is occupied by a placeholder label describing the expected input from the user, e.g. in the case of a field where the user defines an amount to be withdrawn from SvS balance the label could read \u201CAnge belopp\u201D.\n\n## Input-help-text\nWhen text-input is focused the cursor takes the position of the placeholder, and the label is moved up to the upper edge of the frame. The label can remain as is after the transition, or label can be replaced by input-help-text in the focus state. Input-help-text is used to help guide the user to provide input in the expected format, e.g. if a numerical value is expected or maximum number of characters allowed.\n\n## Explanation\nIf further explanation is required in order to guide the user, the explanation field can be utilized. This text field is static and will not change during interaction with the text field, which can be useful for providing guidance prior to the user interacting with the text field.\n\n## Suffix\nText-input allows for adding a suffix at the end of the input field. The principle use case for this function is adding \u201Ckr\u201D in a text field where a monetary value is the expected input.\n\n## Icon\nText-input supports an icon at the right end of the text field, which is only used for password fields, where an eye icon acts as a button for showing / hiding the contents of a password field.\n\n## Disabled state\nIf the input field should not allow for interaction, e.g. if a prior input is required before allowing input, the input field can be made disabled and non-interactable.\n\n## Error\nIf an erroneous input is encountered the input field will enter the error state, with the underline turning red and an error-message describing the error and if possible, how to fix it. Ideally the user should be provided enough guidance prior in order to avoid encountering an error.\n\n## Inverted\nIf text-input is placed against a darker background the inverted version of the component should be used.\n\n## Multi-line\nIn cases where the expected input is a longer message the text field can be made multiline which will allow for multiple lines of input. In other regards, multiline text-input behaves similarly to the default component, including error states, etc.",
    "methods": [],
    "displayName": "Inputv2",
    "props": {
      "autoCapitalize": {
        "defaultValue": {
          "value": "'off'",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "autoComplete": {
        "defaultValue": {
          "value": "'on'",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "className": {
        "defaultValue": {
          "value": "''",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "hasFormData": {
        "defaultValue": {
          "value": "false",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "isSmall": {
        "defaultValue": {
          "value": "false",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "prefix": {
        "defaultValue": {
          "value": "null",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "node"
        },
        "required": false
      },
      "refElem": {
        "defaultValue": {
          "value": "null",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "union",
          "value": [{
            "name": "object"
          }, {
            "name": "func"
          }]
        },
        "required": false
      },
      "selectOnFocus": {
        "defaultValue": {
          "value": "true",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "showPassword": {
        "defaultValue": {
          "value": "true",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "suffix": {
        "defaultValue": {
          "value": "null",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "node"
        },
        "required": false
      },
      "id": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "inputHelpText": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "inverted": {
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "label": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "multiline": {
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "onClick": {
        "description": "",
        "type": {
          "name": "func"
        },
        "required": false
      },
      "onFocus": {
        "description": "",
        "type": {
          "name": "func"
        },
        "required": false
      },
      "size": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "type": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "value": {
        "description": "",
        "type": {
          "name": "union",
          "value": [{
            "name": "number"
          }, {
            "name": "string"
          }]
        },
        "required": true
      }
    }
  };
  const inputv2 = Inputv2;
  (((window.svs = window.svs || {}).ui = window.svs.ui || {}).ReactForm = window.svs.ui.ReactForm || {}).Inputv2 = __webpack_exports__["default"];
})();

 })(window);